import axios from "axios";

export class FeatureService
{
	public AddToCartIsModal = (): Promise<any> =>
	{
		const url = "/api/feature/addToCartIsModal";
		return axios.get(url)
			.catch((error) =>
			{
				console.log(error);
			});
	};
}